import "./App.css";
import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Header from "../../components/Header/Header";
import Promo from "../../components/Promo/Promo";
import About from "../About/About";
import Preview from "../Preview/Preview";
import ButtonsBar from "../ButtonsBar/ButtonsBar";
import Feedback from "../Feedback/Feedback";
import Footer from "../Footer/Footer";

import PropertyDevelopment from "../PropertyDevelopment/PropertyDevelopment";
import ContructionMaterials from "../ContructionMaterials/ContructionMaterials";
import InvestmentOpportnites from "../InvestmentOpportnites/InvestmentOpportnites";
import Gallery from "../Gallery/Gallery";
import Contact from "../Contact/Contact";

function App() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 576); 
    };

    handleResize(); 
    window.addEventListener("resize", handleResize); 

    return () => {
      window.removeEventListener("resize", handleResize); 
    };
  }, []);

  return (
    <div className="app">
      {isMobile ? (
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Header />
                <Promo />
                <About />
                <Preview />
                <Contact />
                {/* <Feedback /> */}
                <ButtonsBar />
                <Footer />
              </>
            }
          />
          <Route
            path="/property-development"
            element={
              <>
                <Header />
                <PropertyDevelopment />
                <ButtonsBar />
                <Footer />
              </>
            }
          />
          <Route
            path="/construction-materials"
            element={
              <>
                <Header />
                <ContructionMaterials />
                <ButtonsBar />
                <Footer />
              </>
            }
          />
          <Route
            path="/investment-opportnites"
            element={
              <>
                <Header />
                <InvestmentOpportnites />
                <ButtonsBar />
                <Footer />
              </>
            }
          />
          <Route
            path="/gallery"
            element={
              <>
                <Header />
                <Gallery />
                <ButtonsBar />
                <Footer />
              </>
            }
          />
        </Routes>
      ) : (
        <div className="desktop-placeholder">
          <h2>This site is designed for mobile devices only.</h2>
        </div>
      )}
    </div>
  );
}

export default App;
